import * as dayjs from "dayjs";

export const STATES_EUA = [
{name:	'Alabama (AL)'	,	 shortName: 	'AL'	,	 image:	'AL.jpg'	},
{name:	'Alaska (AK)'	,	 shortName: 	'AK'	,	 image:	'AK.jpg'	},
{name:	'Arizona (AZ)'	,	 shortName: 	'AZ'	,	 image:	'AZ.jpg'	},
{name:	'Arkansas (AR)'	,	 shortName: 	'AR'	,	 image:	'AR.jpg'	},
{name:	'California (CA)'	,	 shortName: 	'CA'	,	 image:	'CA.jpg'	},
{name:	'Carolina del Norte (NC)'	,	 shortName: 	'NC'	,	 image:	'NC.jpg'	},
{name:	'Carolina del Sur (SC)'	,	 shortName: 	'SC'	,	 image:	'SC.jpg'	},
{name:	'Colorado (CO)'	,	 shortName: 	'CO'	,	 image:	'CO.jpg'	},
{name:	'Connecticut (CT)'	,	 shortName: 	'CT'	,	 image:	'CT.jpg'	},
{name:	'Dakota del Norte (ND)'	,	 shortName: 	'ND'	,	 image:	'ND.jpg'	},
{name:	'Dakota del Sur (SD)'	,	 shortName: 	'SD'	,	 image:	'SD.jpg'	},
{name:	'Delaware (DE)'	,	 shortName: 	'DE'	,	 image:	'DE.jpg'	},
{name:	'Florida (FL)'	,	 shortName: 	'FL'	,	 image:	'FL.jpg'	},
{name:	'Georgia (GA)'	,	 shortName: 	'GA'	,	 image:	'GA.jpg'	},
{name:	'Hawái (HI)'	,	 shortName: 	'HI'	,	 image:	'HI.jpg'	},
{name:	'Idaho (ID)'	,	 shortName: 	'ID'	,	 image:	'ID.jpg'	},
{name:	'Illinois (IL)'	,	 shortName: 	'IL'	,	 image:	'IL.jpg'	},
{name:	'Indiana (IN)'	,	 shortName: 	'IN'	,	 image:	'IN.jpg'	},
{name:	'Iowa (IA)'	,	 shortName: 	'IA'	,	 image:	'IA.jpg'	},
{name:	'Kansas (KS)'	,	 shortName: 	'KS'	,	 image:	'KS.jpg'	},
{name:	'Kentucky (KY)'	,	 shortName: 	'KY'	,	 image:	'KY.jpg'	},
{name:	'Luisiana (LA)'	,	 shortName: 	'LA'	,	 image:	'LA.jpg'	},
{name:	'Maine (ME)'	,	 shortName: 	'ME'	,	 image:	'ME.jpg'	},
{name:	'Maryland (MD)'	,	 shortName: 	'MD'	,	 image:	'MD.jpg'	},
{name:	'Massachusetts (MA)'	,	 shortName: 	'MA'	,	 image:	'MA.jpg'	},
{name:	'Míchigan (MI)'	,	 shortName: 	'MI'	,	 image:	'MI.jpg'	},
{name:	'Minnesota (MN)'	,	 shortName: 	'MN'	,	 image:	'MN.jpg'	},
{name:	'Misisipi (MS)'	,	 shortName: 	'MS'	,	 image:	'MS.jpg'	},
{name:	'Misuri (MO)'	,	 shortName: 	'MO'	,	 image:	'MO.jpg'	},
{name:	'Montana (MT)'	,	 shortName: 	'MT'	,	 image:	'MT.jpg'	},
{name:	'Nebraska (NE)'	,	 shortName: 	'NE'	,	 image:	'NE.jpg'	},
{name:	'Nevada (NV)'	,	 shortName: 	'NV'	,	 image:	'NV.jpg'	},
{name:	'Nueva Jersey (NJ)'	,	 shortName: 	'NJ'	,	 image:	'NJ.jpg'	},
{name:	'Nueva York (NY)'	,	 shortName: 	'NY'	,	 image:	'NY.jpg'	},
{name:	'Nuevo Hampshire (NH)'	,	 shortName: 	'NH'	,	 image:	'NH.jpg'	},
{name:	'Nuevo México (NM)'	,	 shortName: 	'NM'	,	 image:	'NM.jpg'	},
{name:	'Ohio (OH)'	,	 shortName: 	'OH'	,	 image:	'OH.jpg'	},
{name:	'Oklahoma (OK)'	,	 shortName: 	'OK'	,	 image:	'OK.jpg'	},
{name:	'Oregón (OR)'	,	 shortName: 	'OR'	,	 image:	'OR.jpg'	},
{name:	'Pensilvania (PA)'	,	 shortName: 	'PA'	,	 image:	'PA.jpg'	},
{name:	'Rhode Island (RI)'	,	 shortName: 	'RI'	,	 image:	'RI.jpg'	},
{name:	'Tennessee (TN)'	,	 shortName: 	'TN'	,	 image:	'TN.jpg'	},
{name:	'Texas (TX)'	,	 shortName: 	'TX'	,	 image:	'TX.jpg'	},
{name:	'Utah (UT)'	,	 shortName: 	'UT'	,	 image:	'UT.jpg'	},
{name:	'Vermont (VT)'	,	 shortName: 	'VT'	,	 image:	'VT.jpg'	},
{name:	'Virginia (VA)'	,	 shortName: 	'VA'	,	 image:	'VA.jpg'	},
{name:	'Virginia Occidental (WV)'	,	 shortName: 	'WV'	,	 image:	'WV.jpg'	},
{name:	'Washington (WA)'	,	 shortName: 	'WA'	,	 image:	'WA.jpg'	},
{name:	'Wisconsin (WI)'	,	 shortName: 	'WI'	,	 image:	'WI.jpg'	},
{name:	'Wyoming (WY)'	,	 shortName: 	'WY'	,	 image:	'WY.jpg'	}
]

export const STATES = [
	{ name: 'Alabama', smallName: 'AL' },
	{ name: 'Alaska', smallName: 'AK' },
	{ name: 'Arizona', smallName: 'AZ' },
	{ name: 'Arkansas', smallName: 'AR' },
	{ name: 'California', smallName: 'CA' },
	{ name: 'Colorado', smallName: 'CO' },
	{ name: 'Connecticut', smallName: 'CT' },
	{ name: 'Delaware', smallName: 'DE' },
	{ name: 'Florida', smallName: 'FL' },
	{ name: 'Georgia', smallName: 'GA' },
	{ name: 'Hawaii', smallName: 'HI' },
	{ name: 'Idaho', smallName: 'ID' },
	{ name: 'Illinois', smallName: 'IL' },
	{ name: 'Indiana', smallName: 'IN' },
	{ name: 'Iowa', smallName: 'IA' },
	{ name: 'Kansas', smallName: 'KS' },
	{ name: 'Kentucky', smallName: 'KY' },
	{ name: 'Louisiana', smallName: 'LA' },
	{ name: 'Maine', smallName: 'ME' },
	{ name: 'Maryland', smallName: 'MD' },
	{ name: 'Massachusetts', smallName: 'MA' },
	{ name: 'Michigan', smallName: 'MI' },
	{ name: 'Minnesota', smallName: 'MN' },
	{ name: 'Mississippi', smallName: 'MS' },
	{ name: 'Missouri', smallName: 'MO' },
	{ name: 'Montana', smallName: 'MT' },
	{ name: 'Nebraska', smallName: 'NE' },
	{ name: 'Nevada', smallName: 'NV' },
	{ name: 'New Hampshire', smallName: 'NH' },
	{ name: 'New Jersey', smallName: 'NJ' },
	{ name: 'New Mexico', smallName: 'NM' },
	{ name: 'New York', smallName: 'NY' },
	{ name: 'North Carolina', smallName: 'NC' },
	{ name: 'North Dakota', smallName: 'ND' },
	{ name: 'Ohio', smallName: 'OH' },
	{ name: 'Oklahoma', smallName: 'OK' },
	{ name: 'Oregon', smallName: 'OR' },
	{ name: 'Pennsylvania', smallName: 'PA' },
	{ name: 'Rhode Island', smallName: 'RI' },
	{ name: 'South Carolina', smallName: 'SC' },
	{ name: 'South Dakota', smallName: 'SD' },
	{ name: 'Tennessee', smallName: 'TN' },
	{ name: 'Texas', smallName: 'TX' },
	{ name: 'Utah', smallName: 'UT' },
	{ name: 'Vermont', smallName: 'VT' },
	{ name: 'Virginia', smallName: 'VA' },
	{ name: 'Washington', smallName: 'WA' },
	{ name: 'West Virginia', smallName: 'WV' },
	{ name: 'Wisconsin', smallName: 'WI' },
	{ name: 'Wyoming', smallName: 'WY' }
  ];

export const DATE_PICKER_RANGE_PAST = {
	'Last Week': [
		dayjs().day(0).subtract(7, 'days').format('YYYY-MM-DD'),
		dayjs().day(6).subtract(7, 'days').format('YYYY-MM-DD'),
	],
	'Last month': [
		dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 2 months': [
		dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 3 months': [
		dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Last year': [
		dayjs().startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
		dayjs().endOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
	],
};

export const DATE_PICKER_RANGE_FUTURE= {
	'Today': [
		dayjs().format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Current Week': [
		dayjs().startOf('week').format('YYYY-MM-DD'),
		dayjs().endOf('week').format('YYYY-MM-DD'),
	],
	'Current month': [
		dayjs().startOf('month').format('YYYY-MM-DD'),
		dayjs().endOf('month').format('YYYY-MM-DD'),
	],
	'Current Year': [
		dayjs().startOf('year').format('YYYY-MM-DD'),
		dayjs().endOf('year').format('YYYY-MM-DD'),
	],
	'All': [
		dayjs().startOf('year').subtract(3, 'year').format('YYYY-MM-DD'),
		dayjs().endOf('year').add(3, 'year').format('YYYY-MM-DD'),
	]
};

export const TIME_ZONES = [
	{
		name: 'ALASKA DAYLIGHT TIME UTC - 8',
		shortName: 'AKDT',
	},
	{
		name: 'ALASKA TIME UTC - 9',
		shortName: 'AKST',
	},
	{
		name: 'ATLANTIC STANDARD TIME	UTC - 4',
		shortName: 'AST',
	},
	{
		name: 'CENTRAL DAYLIGHT TIME UTC - 5',
		shortName: 'CDT',
	},
	{
		name: 'CENTRAL STANDARD TIME UTC - 6',
		shortName: 'CST',
	},
	{
		name: 'EASTERN DAYLIGHT TIME UTC - 4',
		shortName: 'EDT',
	},
	{
		name: 'EASTERN STANDARD TIME UTC - 5',
		shortName: 'EST',
	},
	{
		name: 'HAWAII-ALEUTIAN DAYLIGHT TIME UTC - 9',
		shortName: 'HADT',
	},
	{
		name: 'HAWAII-ALEUTIAN STANDARD TIME	UTC - 10',
		shortName: 'HAST',
	},
	{
		name: 'HAWAII STANDARD TIME UTC - 10',
		shortName: 'HST',
	},
	{
		name: 'MOUNTAIN DAYLIGHT TIME	UTC - 6',
		shortName: 'MDT',
	},
	{
		name: 'MOUNTAIN STANDARD TIME	UTC - 7',
		shortName: 'MST',
	},
	{
		name: 'PACIFIC DAYLIGHT TIME UTC - 7',
		shortName: 'PDT',
	},
	{
		name: 'PACIFIC STANDARD TIME UTC - 8',
		shortName: 'PST',
	},
];

// SUPER USERS FEATURES

export const CHANGE_TO_CUSTOMER_VIEW = [
	'ltejeda@t3direct.com',
	'vkapella@t3direc.com',
	'hiram@t3direct.com'
];

export const LEAD_STATUS = [
	'',
	'Unreviewed',
	'Approved',
	'Denied',
	'Fix',
	'Rescheduled',
	'Criteria Reject',
	'Closed'
];
